
import actionTypes from './actionTypes';

const initialState = {
    openModalUtilizar: false,
};

const actions = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.MODAL_UTILIZAR_VOCHER_OPEN:
            return {
                ...state,
                openModalUtilizar: true,
            };
        case actionTypes.MODAL_UTILIZAR_VOCHER_CLOSE:
            return {
                ...state,
                openModalUtilizar: false,
            };
        default:
            return state;
    }
};

export default actions;
